/**
 * CANONICAL support taxonomy — mirror of apna-yatri-backend/src/data/supportEnums.ts. Keep in sync.
 * The admin ticket-type filter previously used codes (payment_issue|ride_issue|…) that matched ZERO
 * tickets (backend writes fare|trip|…). Everyone must use THESE codes now.
 */

export const SUPPORT_ISSUE_TYPES = [
  'fare', 'lost_item', 'safety', 'vehicle', 'app', 'account_deletion', 'trip',
  'driver_payout', 'earnings_dispute', 'cash_not_collected', 'document_rejected',
  'subscription', 'wallet', 'account_suspension', 'rider_behaviour', 'onboarding',
  'general',
] as const;
export type SupportIssueType = (typeof SUPPORT_ISSUE_TYPES)[number];

export const ISSUE_TYPE_LABELS: Record<string, string> = {
  fare: 'Fare / Payment', lost_item: 'Lost Item', safety: 'Safety', vehicle: 'Vehicle',
  app: 'App Issue', account_deletion: 'Account Deletion', trip: 'Trip',
  driver_payout: 'Driver Payout', earnings_dispute: 'Earnings Dispute',
  cash_not_collected: 'Cash Not Collected', document_rejected: 'Document Rejected',
  subscription: 'Subscription', wallet: 'Wallet', account_suspension: 'Account Suspension',
  rider_behaviour: 'Rider Behaviour', onboarding: 'Onboarding', general: 'General',
};
export const issueTypeLabel = (code: string): string => ISSUE_TYPE_LABELS[code] ?? code;

export const TICKET_STATUSES = ['new', 'open', 'in_progress', 'pending_customer', 'resolved', 'closed'] as const;
export type TicketStatus = (typeof TICKET_STATUSES)[number];
export const STATUS_LABELS: Record<string, string> = {
  new: 'New', open: 'Open', in_progress: 'In Progress', pending_customer: 'Pending Customer',
  resolved: 'Resolved', closed: 'Closed',
};
export const isOpenStatus = (s: string): boolean => !['resolved', 'closed'].includes(s);

export const TICKET_PRIORITIES = ['p0_safety', 'urgent', 'high', 'normal', 'low'] as const;
export type TicketPriority = (typeof TICKET_PRIORITIES)[number];
export const PRIORITY_LABELS: Record<string, string> = {
  p0_safety: 'P0 · Safety', urgent: 'Urgent', high: 'High', normal: 'Normal', low: 'Low',
};
/** Chip color per priority (MUI-ish palette keys the components can map). */
export const PRIORITY_COLOR: Record<string, 'error' | 'warning' | 'info' | 'default' | 'success'> = {
  p0_safety: 'error', urgent: 'error', high: 'warning', normal: 'info', low: 'default',
};

export const TICKET_SOURCES = ['app_chat', 'whatsapp', 'ivr_voice', 'email', 'agent_manual', 'bot'] as const;
export type TicketSource = (typeof TICKET_SOURCES)[number];
